import { combineReducers } from 'redux'
import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'workflow-configuration',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Workflow = require('./containers/WorkflowContainer').default
      const workflowReducer = require('./modules/workflow').default

      /*  Add the reducer to the store on key 'workflow'  */
      injectReducer(store, {
        key: 'configuration',
        reducer: combineReducers({
          workflow: workflowReducer
        })
      })

      /*  Return getComponent   */
      cb(null, Workflow)

    /* Webpack named bundle   */
    }, 'workflow')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Workflow/index.js